import { LanguageType, VariantResponseDto } from '@tiendanube/common';

export const joinVariantValues = (
  variant: VariantResponseDto,
  language: LanguageType,
) => variant.values.map((v) => v[language]).join(' / ');
